import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { UserChannel, useAuth } from "@saleor/sdk";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader } from "@temp/components";
import * as paths from "../../app/routes/paths";
import { WebDeliverymanLogin } from "./Login/WebDeliverymanLogin";
export var WebDeliveryman = function WebDeliveryman() {
  var _useAuth = useAuth(),
      user = _useAuth.user,
      signOut = _useAuth.signOut;

  var _useParams = useParams(),
      slug = _useParams.slug;

  var navigate = useNavigate();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showLogin = _React$useState2[0],
      setShowLogin = _React$useState2[1];

  var _useAuth2 = useAuth(),
      loadUserCheckout = _useAuth2.loadUserCheckout,
      isCurrentTokenValid = _useAuth2.isCurrentTokenValid;

  var handleVerifyToken = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _user$currentTrade, _user$currentTrade$sl, _user$lastChannel, _UserChannel$ECOMMERC;

      var _yield$isCurrentToken, isValid, _yield$loadUserChecko, executed;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!((user === null || user === void 0 ? void 0 : (_user$currentTrade = user.currentTrade) === null || _user$currentTrade === void 0 ? void 0 : (_user$currentTrade$sl = _user$currentTrade.slugMainTrade) === null || _user$currentTrade$sl === void 0 ? void 0 : _user$currentTrade$sl.toLowerCase()) === (slug === null || slug === void 0 ? void 0 : slug.toLowerCase()) && (user === null || user === void 0 ? void 0 : (_user$lastChannel = user.lastChannel) === null || _user$lastChannel === void 0 ? void 0 : _user$lastChannel.toUpperCase()) === (UserChannel === null || UserChannel === void 0 ? void 0 : (_UserChannel$ECOMMERC = UserChannel.ECOMMERCE) === null || _UserChannel$ECOMMERC === void 0 ? void 0 : _UserChannel$ECOMMERC.toUpperCase()))) {
                _context.next = 20;
                break;
              }

              window.avoidRefreshSignInToken();
              _context.next = 4;
              return isCurrentTokenValid();

            case 4:
              _yield$isCurrentToken = _context.sent;
              isValid = _yield$isCurrentToken.isValid;
              _context.next = 8;
              return loadUserCheckout(isValid);

            case 8:
              _yield$loadUserChecko = _context.sent;
              executed = _yield$loadUserChecko.executed;
              window.allowRefreshSignInToken();

              if (!(executed && isValid)) {
                _context.next = 15;
                break;
              }

              navigate(paths.baseUrl);
              _context.next = 18;
              break;

            case 15:
              _context.next = 17;
              return signOut();

            case 17:
              setShowLogin(true);

            case 18:
              _context.next = 27;
              break;

            case 20:
              if (!(user === null || user === void 0 ? void 0 : user.id)) {
                _context.next = 26;
                break;
              }

              _context.next = 23;
              return signOut();

            case 23:
              setShowLogin(true);
              _context.next = 27;
              break;

            case 26:
              setShowLogin(true);

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleVerifyToken() {
      return _ref.apply(this, arguments);
    };
  }();

  React.useEffect(function () {
    handleVerifyToken();
  }, []);
  return React.createElement(React.Fragment, null, showLogin ? React.createElement(WebDeliverymanLogin, null) : React.createElement("div", {
    className: "ecommerce__loading"
  }, React.createElement(Loader, null)));
};